import { useEffect } from "react";
import { NextPageContext } from "next";
import { getSession } from "next-auth/client";
import isLoggedIn from "src/utils/isLoggedIn";
import { authRedirect } from "src/modules/page/utils";
import { LoginView } from "src/organisms/login";
import LoginPages from "src/Layouts/LoginPages";
import { useRouter } from "next/router";

const LoginPage = (): JSX.Element => {
  const router = useRouter();

  useEffect(() => {
    if (router.asPath.includes("#register")) {
      void router.push("/register");
    }
    if (router.asPath.includes("#forgot-password")) {
      void router.push("/reset-password");
    }
  }, [router]);

  return <LoginView />;
};

LoginPage.getInitialProps = async (ctx: NextPageContext) => {
  if (ctx.req && ctx.res) {
    const session = await getSession({ req: ctx.req });
    if (isLoggedIn(session)) {
      authRedirect(ctx, session);
    }
  }
  return {};
};
LoginPage.Layout = LoginPages;

export default LoginPage;
